enum ResolutionTimeRoutesAPI {
  TOTAL_OS = '/customer-portal-service/ResolutionTime/TotalOS',
  TOTAL_RESOLUTION_TIME = '/customer-portal-service/ResolutionTime/TotalResolutionTime',
}

enum ResolutionTimeRoutesApplication {
  RESOLUTION_TIME = '/application/resolution-time'
}

export {
  ResolutionTimeRoutesAPI,
  ResolutionTimeRoutesApplication,
};
